import { getPlpListingKey } from '@/features/plp/utils/plpUrl';

export const RECENTLY_VIEWED_PATH = '/recently-viewed';

export function isRecentlyViewedRoute(pathname: string): boolean {
  const path = pathname.split('?')[0].replace(/\/+$/, '') || '/';
  return path === RECENTLY_VIEWED_PATH;
}

export function getRecentlyViewedActiveCategoryFromSearch(search: string): string {
  const raw = new URLSearchParams(search).get('category')?.trim().toLowerCase();
  return raw || 'all';
}

export function getRecentlyViewedApiCategoryFromSearch(search: string): string | undefined {
  const active = getRecentlyViewedActiveCategoryFromSearch(search);
  if (!active || active === 'all') return undefined;
  return active;
}

export function getRecentlyViewedListingKey(pathnameOrUrl: string, search?: string): string {
  return getPlpListingKey(pathnameOrUrl, search);
}
